// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

/******************** layout components ********************/
import Header from './components/Header';
import Footer from './components/Footer';

/******************** routed-pages ********************/
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ServicesOverview from './pages/ServicesOverview';
import Languages from './pages/Languages';
import Industry from './pages/Industry';
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import MultimediaAndDtpServices from './pages/MultimediaAndDtpServices';
import AudioAndVideoTranscription from './pages/AudioAndVideoTranscription';
import Subtitling from './pages/Subtitling';
import DesktopPublishingServices from './pages/DesktopPublishingServices';
import MultilingualDesktopPublishing from './pages/MultilingualDesktopPublishing';
import MultimediaAndDTPTools from './pages/MultimediaAndDTPTools';

// Newly added pages
import DataAnnotationServices from './pages/DataAnnotationServices';
import ChatPromptOptimization from './pages/ChatPromptOptimization';
import ImageProcessingAndLabeling from './pages/ImageProcessingAndLabeling';
import ChatbotTrainingAndTesting from './pages/ChatbotTrainingAndTesting';
import ImageLocalizationEditingAndRetouching from './pages/ImageLocalizationEditingAndRetouching';
import ImmersiveTechnologies from './pages/ImmersiveTechnologies';

function App() {
  /* -------------------------------------------------------------
     kick-off animate-on-scroll (AOS) once, after the very first
     render. "once: true" = each element animates only the first
     time it scrolls into view.
  ----------------------------------------------------------------*/
  useEffect(() => {
    AOS.init({ duration: 700, easing: 'ease-out-cubic', once: true });
  }, []);

  return (
    <Router>
      {/* flex-box column so the footer is pushed to the bottom */}
      <div className="d-flex flex-column min-vh-100">
        <Header />

        {/* main grows to fill the space between nav & footer */}
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />

            {/* Translation services */}
            <Route path="/services" element={<ServicesOverview />} />

            {/* Other sections */}
            <Route path="/languages" element={<Languages />} />
            <Route path="/industry" element={<Industry />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* Multimedia & DTP Services page */}
            <Route path="/multimedia-and-dtp-services" element={<MultimediaAndDtpServices />} />

            {/* AI Services pages */}
            <Route path="/data-annotation-services" element={<DataAnnotationServices />} />
            <Route path="/chat-prompt-optimization" element={<ChatPromptOptimization />} />
            <Route path="/image-processing-and-labeling" element={<ImageProcessingAndLabeling />} />
            <Route path="/chatbot-training-and-testing" element={<ChatbotTrainingAndTesting />} />
            <Route path="/image-localization-editing-and-retouching" element={<ImageLocalizationEditingAndRetouching />} />
            <Route path="/immersive-technologies" element={<ImmersiveTechnologies />} />

            {/* Other pages */}
            <Route path="/audio-and-video-transcription" element={<AudioAndVideoTranscription />} />
            <Route path="/subtitling" element={<Subtitling />} />
            <Route path="/desktop-publishing-services" element={<DesktopPublishingServices />} />
            <Route path="/multilingual-desktop-publishing" element={<MultilingualDesktopPublishing />} />
            <Route path="/multimedia-and-dtp-tools" element={<MultimediaAndDTPTools />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;